import L from 'leaflet';
import $ from 'jquery';
import LeafletTopojson from './Map/leaflet.topojson'
import inView from 'in-view';

LeafletTopojson.init(L);

import { disableMap } from '~/core/scripts/map-components/utils';

function init() {
  $.ajax({ url: 'data/berlin-districts-simple.json', dataType: 'json' })
    .done(geoData => {
      inView('.lazy-map')
        .on('enter', createLocatorMap(geoData));
    });
}

function createLocatorMap(topoJson) {
  return elm => {
    const $elm = $(elm);

    if ($elm.hasClass('map-loaded')) {
      return false;
    }

    const pointCenter = JSON.parse($elm.attr('data-center'));
    $elm.addClass('map-loaded');

    const mapOptions = {
      center: [52.511784, 13.443181],
      bounds: [[52, 12],[53, 15]]
    };

    const topoLayer = new L.TopoJSONMesh;

    const map = L.map(elm, {
      zoomControl: false,
      center: mapOptions.center,
      attributionControl: false,
      zoomDelta: 0.1,
      zoomSnap: 0.1
    });

    disableMap(map);
    map.dragging.disable();
    if (map.tap) map.tap.disable();

    topoLayer.addData(topoJson);
    topoLayer.addTo(map);

    map.fitBounds(topoLayer.getBounds(), { padding: [2, 2] })

    styleLayer(topoLayer);

    L.circle(pointCenter, { radius: 1500, fillOpacity: 1, fillColor: '#00E4FF', stroke: false }).addTo(map);
  }
}

function styleLayer(_layer) {
  _layer.eachLayer(layer => {
    layer.setStyle({
      fill: false,
      weight: 1,
      color: '#777',
      strokeOpacity: 0.5
    });
  });
}

export default {
  init
};
